import { isMockTenant, getMockCallouts } from './src-mock-mockData.js';
import defaultAxios from './src-providers-axios-provider.js';

const SERVICE_HOST = "https://campaign-callouts.prod.merch.vpsvc.com";
const REQUESTOR = "campaignCalloutsComponent";
class CampaignCalloutsServiceClient {
  async getCalloutsByLocale(tenant, locale, allExperiments, previewDate) {
    if (isMockTenant(tenant)) {
      return getMockCallouts();
    }
    let serviceReponse;
    try {
      if (previewDate == null || previewDate.trim().length === 0) {
        serviceReponse = await defaultAxios.post(`${SERVICE_HOST}/api/v2/calloutsForUserContexts/${tenant}/${locale.toLowerCase()}?requestor=${REQUESTOR}`, allExperiments);
      } else {
        serviceReponse = await defaultAxios.post(`${SERVICE_HOST}/api/v2/calloutsForUserContexts/${tenant}/${locale.toLowerCase()}?previewDate=${previewDate}&requestor=${REQUESTOR}`, allExperiments);
      }
      return serviceReponse.data;
    } catch (e) {
      throw new Error(`Couldn't perform request against campaign callouts service due to ${e}`);
    }
  }
}

export { CampaignCalloutsServiceClient as default };
//# sourceMappingURL=src-clients-campaign-callouts-service-client.js.map
